import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4RoommatesArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'Does HO-4 Cover Roommates? | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        'content',
        'Learn how HO-4 renters insurance works with roommates and when separate policies are usually recommended.'
      );
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/does-ho4-cover-roommates"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>Does HO-4 cover roommates?</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>
              Roommate coverage depends on who is named on the policy and your carrier rules.
            </p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4">
            <div className="card-body">
              <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
              <p>
                In many cases, a roommate&apos;s belongings are not automatically covered by your HO-4 policy unless they
                are a named insured. Separate policies are often the cleanest option.
              </p>
              <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>What to check</h3>
              <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>Who is listed as a named insured on the policy.</li>
                <li style={{ marginBottom: '0.5rem' }}>How personal property limits apply between people.</li>
                <li style={{ marginBottom: '0.5rem' }}>How liability claims are handled for shared spaces.</li>
                <li>Lease requirements for each occupant.</li>
              </ul>
              <p style={{ marginTop: '1rem', marginBottom: 0 }}>
                Review your{' '}
                <Link to="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance" style={articleLinkStyle}>
                  liability limit
                </Link>{' '}
                and{' '}
                <Link to="/knowledge-base/is-ho4-required-by-landlord" style={articleLinkStyle}>
                  landlord requirements
                </Link>{' '}
                when living with roommates.
              </p>
            </div>
          </article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Get a setup that works for your shared housing arrangement.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need roommate policy advice?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can help determine whether one policy or separate policies fit best.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4RoommatesArticlePage;

